export default "__VITE_ASSET__Ctv1YHhY__"